import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RESOURCES } from 'OpsCenter/app.constants';

@Injectable()
export class ReservationsImportService {
  constructor(private http: HttpClient) {}

  uploadFile(merchantId: number, email: string, file: File) {
    const formData: FormData = new FormData();
    formData.append('email', new Blob([email]));
    formData.append('attachment', file, file.name);

    return this.http.post(`${RESOURCES.MERCHANT}/${merchantId}/import_reservations`, formData);
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/importing/reservations/reservations-import.service.ts